module.exports = __webpack_public_path__ + "img/Dantam Fashion 01.ed1090f7.jpg";